import React from 'react'
import { Layout, Sidebar, TwoColumns } from 'app/theme/layout'

export default function CountryPage() {
  return (
    <Layout className="container py-10">
      <TwoColumns sidebar={<Sidebar />}>

      </TwoColumns>
    </Layout>
  )
}
